exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".action-wrapper-attendee .addFirst {\n  display: none !important; }\n\n.action-wrapper-attendee .removeFirst {\n  display: inherit !important; }\n\n.action-wrapper-attendee:last-child .addFirst {\n  display: inherit !important; }\n\n.action-wrapper-attendee:last-child .removeFirst {\n  display: none !important; }\n\n.line-heigh-1 {\n  line-height: 1rem; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/crm/set-attendees/set-attendees.component.scss
// module id = ../../../../../src/app/crm/set-attendees/set-attendees.component.scss
// module chunks = main